/* eslint-disable eqeqeq */
/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable no-promise-executor-return */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable react-hooks/exhaustive-deps */

import React, { useEffect, useState } from 'react';
import { Routes, Route, Navigate, BrowserRouter } from 'react-router-dom';

import { toast } from 'react-toastify';
import { TrackingProvider } from '../context/TrackingContext';

import Login from '../pages/SignIn';
import SignUp from '../pages/SignUp';
import SignUpConfirmEmail from '../pages/SignUp/confirmEmail';
import SignUpPhone from '../pages/SignUp/phone';
import SignUpConfirmPhone from '../pages/SignUp/confirmPhone';
import SignUpFinish from '../pages/SignUp/finish';
import User from '../pages/User';
import UserUpdate from '../pages/User/Update';
import UserUpdateEmail from '../pages/User/Update/email';
import UserUpdateConfirmEmail from '../pages/User/Update/confirmEmail';
import UserUpdatePhone from '../pages/User/Update/phone';
import UserUpdateConfirmPhone from '../pages/User/Update/confirmPhone';
import AddressCreate from '../pages/User/Address/Create';
import AddressMap from '../pages/User/Address/Map';
import AddressList from '../pages/User/Address/List';
import Request from '../pages/User/Request';
import RequestChat from '../pages/User/Request/Chat';
import RequestChatConversation from '../pages/User/Request/ChatConversation';
import OrderDetail from '../pages/User/Request/Detail';
import RequestRate from '../pages/User/Request/Rate';
import UploadFilePix from '../pages/User/Request/UploadFilePix';
import Explore from '../pages/Explore';
import Segments from '../pages/Shop';
import ListShops from '../pages/Shop/List';
import DetailShop from '../pages/Shop/Detail';
import DetailSubCategoryShop from '../pages/Shop/DetailSubCategory';
import RatingShop from '../pages/Shop/Rating';
import AbountShop from '../pages/Shop/Abount';
import ProductRequestShop from '../pages/Shop/Order';
import DetailRequestShop from '../pages/Shop/Order/Cart';
import NoteRequestShop from '../pages/Shop/Order/Note';
import AdditionalRequestShop from '../pages/Shop/Order/Additional';
import FlavorRequestShop from '../pages/Shop/Order/Flavor';
import OptionLevelRequestShop from '../pages/Shop/Order/OptionLevel';
import SplashScreen from '../components/SplashScreen';
import Loading from '../components/Loading';

import { useLoadingContext } from '../providers/use-loading';
import { useSignInContext } from '../providers/use-signin';
import { ItypeReturnApi } from '../helpers/utils/TypeReturnApi';
import { api } from '../services';
import { getStorege, saveStorege } from '../helpers/db_storage';
import SelectedShopShare from '../pages/SelectedShopShare';
import SelectedStateCity from '../pages/SelectedStateCity';
import Promotion from '../pages/promotion';
import { coordinates } from '../helpers/utils/locationCoordinates';
import Extract from '../pages/User/Fidelity/Extract';
import IndicateWin from '../pages/User/Fidelity/IndicateWin';
import CashBack from '../pages/User/Fidelity/CashBack';
import Fidelity from '../pages/User/Fidelity';
import Awardedorder from '../pages/User/Fidelity/Awardedorder';
import Winningregister from '../pages/User/Fidelity/Winningregister';
import FavoritesPage from '../pages/User/Favorites';

type IUserOrders = {
  token: string;
  idUsuario: any;
};

const App: React.FC = () => {
  const loading = useLoadingContext();
  const signInContext = useSignInContext();

  const [splashScreen, setSplashScreen] = useState(true);
  const [tokenOrders, setTokenOrders] = useState<IUserOrders>(
    {} as IUserOrders,
  );

  const selectedStateCity =
    window.location.pathname.split('/')[1] +
    window.location.pathname.split('/')[2] +
    window.location.pathname.split('/')[3] +
    window.location.pathname.split('/')[4];

  useEffect(() => {
    async function CloseModal() {
      await new Promise((resolve) => {
        setTimeout(resolve, 2000);
      });
      setSplashScreen(false);
    }
    CloseModal();
  }, []);

  useEffect(() => {
    const setLocationShareLink = async () => {
      if (selectedStateCity === 'pwaselectedstatecity') {
        try {
          const result: ItypeReturnApi =
            await api.apiMaisdelivery.shop.getParamsShop({
              nr_operacao: 46,
              dsUrlSlug:
                window.location.pathname.split('/')[5] == 'promotions' ||
                window.location.pathname.split('/')[5] == 'promotionscity'
                  ? window.location.pathname.split('/')[7]
                  : window.location.pathname.split('/')[6].split('?')[0],
            });

          if (result.data.retorno === 'NOK') {
            toast.info(
              'Cidade não encontrada, por favor selecione cidade desejada',
            );
          }

          const { lat, lng } = await coordinates();

          saveStorege('@mais/delivery/dataStateCity', {
            dsCidade: result.data.dsCidade,
            idMarketplace: result.data.idMarketplace,
            idCidade: result.data.idCidade,
            idEstado: result.data.idEstado,
            lat,
            lng,
          });
          if (window.location.pathname.split('/')[5] == 'promotions') {
            window.location.replace(
              `/pwa/promotions/${window.location.pathname.split('/')[6]}/${
                window.location.pathname.split('/')[7]
              }/${window.location.pathname.split('/')[8]}/${
                window.location.pathname.split('/')[9]
              }/${window.location.pathname.split('/')[7]}`,
            );
            return;
          }
          if (window.location.pathname.split('/')[5] == 'promotionscity') {
            window.location.replace(`/pwa/promotions`);
            return;
          }

          window.location.replace('/pwa/');
        } catch (error) {
          toast.info(
            'Cidade não encontrada, por favor selecione cidade desejada',
          );
        }
      }
    };
    setLocationShareLink();
  }, [selectedStateCity]);

  useEffect(() => {
    const result = getStorege('@mais/delivery/authorization/orders');

    setTokenOrders(result);
  }, []);

  return (
    <BrowserRouter basename="/pwa">
      {loading?.data?.loading && <Loading />}
      <TrackingProvider>
        <Routes>
          {/* Routes User */}
          {signInContext.signed && (
            <Route path="dashboard/user">
              <Route index element={<User />} />
              <Route path="update" element={<UserUpdate />} />
              <Route path="favorites" element={<FavoritesPage />} />
              <Route path="update/email" element={<UserUpdateEmail />} />
              <Route
                path="update/confirm/email"
                element={<UserUpdateConfirmEmail />}
              />
              <Route path="update/phone" element={<UserUpdatePhone />} />
              <Route
                path="update/confirm/phone"
                element={<UserUpdateConfirmPhone />}
              />
              <Route path="address/create">
                <Route index element={<AddressCreate />} />
                <Route path=":params/:id_shop" element={<AddressCreate />} />
              </Route>
              <Route path="address/map">
                <Route index element={<AddressMap />} />
                <Route path=":params/:id_shop" element={<AddressMap />} />
              </Route>
              <Route path="address/list" element={<AddressList />} />
              <Route
                path="request/detail/:id_request/:id_shop"
                element={<OrderDetail />}
              />
              <Route
                path="request/detail/rate/:params"
                element={<RequestRate />}
              />
              <Route path="request/detail/upload/file/pix/:id_request/:id_shop">
                <Route index element={<UploadFilePix />} />
                <Route path=":success_order" element={<UploadFilePix />} />
              </Route>
            </Route>
          )}

          {/* Route Temp orders */}
          {tokenOrders?.token !== '' && (
            <Route path="dashboard/user">
              <Route
                path="request/detail/:id_request/:id_shop"
                element={<OrderDetail />}
              />
              <Route
                path="request/detail/rate/:params"
                element={<RequestRate />}
              />
            </Route>
          )}
          {/* Routes Auth */}
          <Route path="/sign/in">
            <Route index element={<Login />} />
            <Route path=":params/:id_shop" element={<Login />} />
          </Route>
          <Route path="fidelity">
            <Route index element={<Fidelity />} />
            <Route path="cashback" element={<CashBack />} />
            <Route path="awardedorder" element={<Awardedorder />} />
            <Route path="winningregister" element={<Winningregister />} />
            <Route path="indicatewin" element={<IndicateWin />} />
            <Route path="extract" element={<Extract />} />
          </Route>
          <Route path="/sign/up/user">
            <Route index element={<SignUp />} />
            <Route path=":params/:id_shop" element={<SignUp />} />
          </Route>
          <Route path="/sign/up/user/confirm/email">
            <Route index element={<SignUpConfirmEmail />} />
            <Route path=":params/:id_shop" element={<SignUpConfirmEmail />} />
          </Route>
          <Route path="/sign/up/user/phone">
            <Route index element={<SignUpPhone />} />
            <Route path=":params/:id_shop" element={<SignUpPhone />} />
          </Route>
          <Route path="/sign/up/user/confirm/phone">
            <Route index element={<SignUpConfirmPhone />} />
            <Route path=":params/:id_shop" element={<SignUpConfirmPhone />} />
          </Route>
          <Route path="/sign/up/user/finish">
            <Route index element={<SignUpFinish />} />
            <Route path=":params/:id_shop" element={<SignUpFinish />} />
          </Route>
          {/* Routes APP */}
          <Route path="dashboard/user/request" element={<Request />} />
          <Route path="dashboard/user/request/chat" element={<RequestChat />} />
          <Route
            path="dashboard/user/request/chat/conversation"
            element={<RequestChatConversation />}
          />
          <Route path="explore" element={<Explore />} />
          <Route
            path="explore/:state/:city/:idRestaurante/:idPromocao/:dsRestaurante"
            element={<Explore />}
          />
          <Route path="promotions" element={<Promotion />} />
          <Route path="promotionscity/:state/:city" element={<Promotion />} />
          <Route path="promotionsshop/:idRestaurante" element={<Promotion />} />
          <Route path="list/shops/now/open/:tpInterno">
            <Route index element={<ListShops />} />
            <Route path=":search" element={<ListShops />} />
          </Route>
          <Route path="list/shops/:idCategoria">
            <Route index element={<ListShops />} />
            <Route path=":search" element={<ListShops />} />
          </Route>
          <Route path="shop/detail/list/product/subcategorie/:idRestaurante">
            <Route index element={<DetailShop />} />
            <Route path=":promotionShop" element={<DetailShop />} />
            <Route
              path=":id_promotion/:des_promotion"
              element={<DetailShop />}
            />
            <Route
              path=":id_cardapio/:id_categoria/:id_subcategoria"
              element={<DetailShop />}
            />
          </Route>
          <Route path="shop/detail/list/product/:idRestaurante">
            <Route index element={<DetailSubCategoryShop />} />
            <Route
              path=":id_promotion/:des_promotion"
              element={<DetailSubCategoryShop />}
            />
          </Route>
          <Route
            path="shop/detail/rating/:idRestaurante"
            element={<RatingShop />}
          />
          <Route
            path="shop/detail/abount/:idRestaurante"
            element={<AbountShop />}
          />
          <Route
            path="shop/detail/product/request/cart/:id_param/:type"
            element={<ProductRequestShop />}
          />
          <Route
            path="shop/request/detail/:idRestaurante"
            element={<DetailRequestShop />}
          />
          <Route path="shop/request/note/:idRestaurante/:id_product">
            <Route index element={<NoteRequestShop />} />
            <Route
              path=":id_promotion/:des_promotion"
              element={<NoteRequestShop />}
            />
          </Route>
          <Route path="shop/request/additional/:idRestaurante/:id_product/:id_request_menu">
            <Route index element={<AdditionalRequestShop />} />
            <Route
              path=":id_promotion/:des_promotion"
              element={<AdditionalRequestShop />}
            />
          </Route>
          <Route path="shop/request/flavor/:idRestaurante/:id_product/:id_request_menu">
            <Route index element={<FlavorRequestShop />} />
            <Route
              path=":id_promotion/:des_promotion"
              element={<FlavorRequestShop />}
            />
          </Route>
          <Route path="shop/request/level/:idRestaurante/:id_product/:id_request_menu">
            <Route index element={<OptionLevelRequestShop />} />
            <Route
              path=":id_promotion/:des_promotion"
              element={<OptionLevelRequestShop />}
            />
          </Route>
          <Route
            path="/selected/state/city/:state/:city"
            element={<SelectedStateCity />}
          />
          <Route
            path="/selected/state/city/:promotion/:state/:city"
            element={<SelectedStateCity />}
          />

          <Route
            path="/selected/state/city/:promotion/:state/:city/:idRestaurante/:idPromocao/:dsRestaurante"
            element={<SelectedStateCity />}
          />
          <Route
            path="/select/state/city"
            element={<Navigate to="/" replace />}
          />
          <Route
            path="/"
            element={splashScreen ? <SplashScreen /> : <Segments />}
          />
          <Route
            path="/selected/shop/:dsEstado/:dsCidade/:idRestaurante/:dsName"
            element={<SelectedShopShare />}
          />
          <Route
            path="/selected/shop/:promotionShop/:idRestaurante"
            element={<SelectedShopShare />}
          />
        </Routes>
      </TrackingProvider>
    </BrowserRouter>
  );
};

export default App;
